import { render, staticRenderFns } from "./AIIcon.vue?vue&type=template&id=5530968e&scoped=true"
import script from "./AIIcon.vue?vue&type=script&lang=js"
export * from "./AIIcon.vue?vue&type=script&lang=js"
import style0 from "./AIIcon.vue?vue&type=style&index=0&id=5530968e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530968e",
  null
  
)

export default component.exports